export function attachJobParam(job, validate, { truncateParam = false } = {}) {
  if (job.last_date && /^\d+$/.test(String(job.last_date))) {
    job.last_date = validate.convertTimestamp(job.last_date);
  }
  let param = job.job_url ? job.job_url : '';
  param = param.replace(/[^A-Z0-9]+/ig, '-');
  if (truncateParam && param.length > 80) {
    const paramSplit = param.split('-');
    const idLength = paramSplit[paramSplit.length - 1].length;
    param = `${param.substring(0, 80 - (idLength + 1))}-${paramSplit[paramSplit.length - 1]}`;
  }
  job.param = param;
  return job;
}

const APPLY_ONLINE_PATTERN = /^apply\s+online$/i;

export function getApplyButtonLabel(label) {
  if (!label || APPLY_ONLINE_PATTERN.test(String(label).trim())) {
    return 'Apply now';
  }
  return label;
}
